import React, { useMemo } from 'react';

import getPublisherConfig from '../../publishersHelper';

const GlobalStyles: React.FC = () => {
  const config = useMemo(() => getPublisherConfig(), []);
  const styles = useMemo(() => {
    let cssVars = ':root {\n';

    if (config && Object.keys(config).length > 0) {
      Object.entries(config).forEach(([key, value]) => {
        if (typeof key === 'string' && key.startsWith('--')) {
          // Replace "--color-" with "--" in the key
          const modifiedKey = key.replace('--color-', '--');
          cssVars += `  ${modifiedKey}: ${value};\n`;
        }
      });
    }
    cssVars += '}\n';
    return cssVars;
  }, [config]);
  return <style dangerouslySetInnerHTML={{ __html: styles }} />;
};

export default GlobalStyles;
